const skills = {
   1: [
      {
         title: "HTML",
         level: 6,
      },
      {
         title: "CSS",
         level: 5,
      },
      {
         title: "JavaScript",
         level: 5,
      },
      {
         title: "TypeScript",
         level: 4,
      },
      {
         title: "React JS",
         level: 4,
      },
      {
         title: "Vue JS",
         level: 1,
      },
      {
         title: "React Native",
         level: 3,
      },
   ],
   2: [
      {
         title: "Express JS",
         level: 4,
      },
      {
         title: "Node JS",
         level: 4,
      },
      {
         title: "MongoDB",
         level: 3,
      },
      {
         title: "PostgreSQL",
         level: 3,
      },
      {
         title: "Oracle PL/SQL",
         level: 5,
      },
      {
         title: "Git",
         level: 6,
      },
      {
         title: "Python",
         level: 4,
      },
   ],
};

export default skills;
